import { render, staticRenderFns } from "./StorageType.vue?vue&type=template&id=1a191a78&scoped=true&"
import script from "./StorageType.vue?vue&type=script&lang=js&"
export * from "./StorageType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a191a78",
  null
  
)

export default component.exports